import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class MintBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MINT;
}

export default MintBuildingTileEntity;
